import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { validDecimalAndLength } from '../../ModificationsUtils';

export const PetRentCharges = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const petRentCharge = 'petRentCharge';
  const petRentChargeWatch: number = useWatch({ name: petRentCharge });
  const isModEdit = useSelector(selectIsEditMod);
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={petRentCharge}
      rules={{
        required: false,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(petRentCharge) ?? ''}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(petRentCharge, validInput);
              onChange(validInput);
            }
          }}
          InputLabelProps={{
            shrink: petRentChargeWatch ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          variant="filled"
          fullWidth
          id="petRentCharge"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.petRentCharge')}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
